import React, {
  useCallback,
} from 'react';

import useAuthorizedRequest from 'utils/useAuthorizedRequest';

import './style.less';

import {
  Spin,
} from 'antd';

const AuthorizedLink = ({
  href,
  children,
  className="",
  style={},
  download=true,
  mimeType='application/octet-stream',
}) => {
  const handleDownload = useCallback((content) => {
    let anchor = linkRef.current;

    if(!anchor) {
      console.log('ERROR: cannot handle download without an anchor');
      return;
    }

    const windowUrl = window.URL || window.webkitURL;
    const blob = content instanceof Blob
      ? content
      : new Blob(
        [content],
        { type: mimeType }
      );

    const url = windowUrl.createObjectURL(blob);
    anchor.setAttribute('href', url);
    anchor.setAttribute('download', download);
    anchor.click();
    windowUrl.revokeObjectURL(url);
  }, [ // eslint-disable-line react-hooks/exhaustive-deps
    download,
    mimeType,
  ]);

  const handleError = useCallback((error) => {
    console.log('Error fetching', error);
  }, []);

  const {
    linkRef,
    onClick,
    started,
    success,
    error,
  } = useAuthorizedRequest({
    url: href,
    onSuccess: handleDownload,
    onError: handleError,
  });

  const statusClassname = success
    ? 'AuthorizedLink-success'
    : error
      ? 'AuthorizedLink-error'
      : '';

  return (
    <React.Fragment>
      <button
        type="button"
        className={`AuthorizedLink-button ${statusClassname} ${className}`}
        style={style}
        download={download}
        onClick={onClick}
      >
        { children }
        {
          !started ? null
          : (
              <React.Fragment>
                { ' ' }
                <Spin size="small" />
              </React.Fragment>
            )
        }
      </button>
      { /* eslint-disable-next-line */ }
      <a className="AuthorizedLink-anchor" ref={linkRef}></a>
    </React.Fragment>
  );
}

export default AuthorizedLink;
